import React from "react";
import { ChakraProvider } from '@chakra-ui/react';
import { Routes, Route } from "react-router-dom";
import { Box, Flex } from "@chakra-ui/react";
import SignIn from "../views/Auth/SignIn";
import ClientRegister from "../views/Auth/ClientRegister";
import BookAppointment from "../views/Auth/BookAppointment";
import ForgotPassword from "../views/Auth/ForgotPassword";
import theme from '../theme/theme.js';
import SignInClient from "../views/Auth/Client.js";
import Welcome from "../views/Welcome.js";
import PublicFormsHub from "../views/Auth/PublicFormsHub";
import PublicFormFill from "../views/Auth/PublicFormFill";



export default function AuthLayout() {

  
  
  
  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <Flex minH="100vh" direction="column">
        <Box as="main" flex="1">
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/client-register" element={<ClientRegister />} />
            <Route path="/book-appointment" element={<BookAppointment />} />
             <Route path="/client" element={<SignInClient />} />
            <Route path="/forms" element={<PublicFormsHub />} />
            <Route path="/forms/:formId" element={<PublicFormFill />} />
            <Route path="/" element={<Welcome/>} />
          </Routes>
        </Box>
      </Flex>
    </ChakraProvider>
  );
}
